import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { GenericMarkerDescription } from 'components-modules/map-slot-generic/index.js';
import { IModule } from 'redux-state/layout/types.js';
import { ActivityDesc, ActivityTypeCustom } from './activity.js';

/** These props are generated
 * 1. When markers area selected
 * 2. in for national park views - tracks / cycles */
export const ActivityDescription = ({ config, modulePath }: IModule<ActivityTypeCustom & IMapSlotClose>) => {
  const { subtitle, attribution, link, key, ...activityProps } = config;
  return (
    <GenericMarkerDescription key={key} dataModule="marker-description-comp" config={config} modulePath={modulePath}>
      <ActivityDesc {...activityProps} />
    </GenericMarkerDescription>
  );
};
